import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import AddServiceCodeContainer from '../../AddServiceCode/containers/AddServiceCodeContainer';
import { NEARLY_DONE, COMPLETE, INCOMPLETE } from '../../../constants/status-codes';
import ServiceListContainer from '../../ServiceList/ServiceListContainer';
import * as findServicesAction from '../actions/findServiceActions';
import * as updateServiceAction from '../actions/updateServiceActions';
import WorkOrderDetails from '../../Workorder/components/work-order-details/work-order-details';
import { workorderServicesRequest } from '../actions/workOrderServiceActions';
import WorkOrderCompletionFormContainer from '../../WorkOrderCompletionForm/containers/WorkOrderCompletionFormContainer';
import { useWorkOrder } from 'modules/Workorder/api';
import './workLog.scss';
import { useChangeWorkOrderStatus } from 'modules/Workorder/api/use-change-workorder-status';
import { Loader } from 'components';
export const WorkLogContainer = ({ workOrderId = 0 }) => {
    const findServices = useSelector((state) => state.findServices);
    const isFetchingWorkOrderServices = useSelector((state) => state.workOrderServices.isFetchingServices);
    const orderedItems = useSelector((state) => state.workOrderServices.orderedItems);
    const dispatch = useDispatch();
    const findServicesRequest = (id) => dispatch(findServicesAction.findServicesRequest({ workOrderId: id }));
    const requestWorkOrderServices = (id) => dispatch(workorderServicesRequest(id));
    const requestUpdateService = (workOrderId, serviceId, quantity, added, workOrderServiceId) => {
        dispatch(updateServiceAction.requestUpdateService({
            workOrderId,
            serviceId,
            quantity,
            added,
            workOrderServiceId
        }));
    };
    const { workOrder } = useWorkOrder(workOrderId);
    const { changeWorkOrderStatus } = useChangeWorkOrderStatus();
    useEffect(() => {
        requestWorkOrderServices(workOrderId);
        findServicesRequest(workOrderId);
        if ((workOrder === null || workOrder === void 0 ? void 0 : workOrder.isThreeSixty) && workOrder.status !== NEARLY_DONE) {
            changeWorkOrderStatus({
                workOrderId: workOrderId,
                currentStatus: workOrder.status
            });
        }
    }, [workOrderId, workOrder === null || workOrder === void 0 ? void 0 : workOrder.status, workOrder === null || workOrder === void 0 ? void 0 : workOrder.isThreeSixty]);
    const done = workOrder
        ? COMPLETE.includes(workOrder.status) || INCOMPLETE.includes(workOrder.status)
        : false;
    return (_jsx("div", { className: "work__log", children: _jsxs("div", { className: "work__log__content", children: [workOrder && (_jsx(WorkOrderDetails, { done: done, workOrder: workOrder, totalTimeEstimate: orderedItems.totalTimeEstimate, inWorkLog: true })), isFetchingWorkOrderServices || findServices.isFetchingServices ? (_jsx(Loader, {})) : (_jsx(ServiceListContainer, { workOrderId: workOrderId })), !findServices.isFetchingServices && (_jsx(AddServiceCodeContainer, { addServiceCode: true, workOrderServices: orderedItems.itemSummary.map((item) => item.id), workOrderId: workOrderId })), _jsx(WorkOrderCompletionFormContainer, { workOrder: workOrder })] }) }));
};
